<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'

defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
})

// NB: Emitting 'cancel' symbolises intent to cancel trial,
// not to cancel the dialog
const emit = defineEmits<{
  cancel: []
}>()

const { t } = useI18n()

const { isChargebeeTrial } = storeToRefs(useBusinessStore())
const isShown = defineModel<boolean>()
</script>

<template>
  <v-dialog v-model="isShown" max-width="510">
    <v-card data-cy="cancelTrialDialog">
      <v-card-title class="text-h5">
        {{ t('dialog.business.cancel_trial.title') }}
      </v-card-title>
      <v-card-text>
        <div v-if="isChargebeeTrial" class="pb-4">
          <p class="mb-4">{{ t('dialog.business.change_to_starter.text') }}</p>
        </div>
        <div v-else class="pb-4">
          <p class="mb-4">{{ t('dialog.business.cancel_trial.text') }}</p>
          <ul class="pl-6">
            <li>{{ t('dialog.business.downgrade.item_1') }}</li>
            <li>{{ t('dialog.business.downgrade.item_2') }}</li>
            <li>{{ t('dialog.business.downgrade.item_3') }}</li>
          </ul>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <skr-button size="xl" color="info" variant="outlined" @click="isShown = false">
          {{ t('global.no_thanks') }}
        </skr-button>
        <v-spacer />
        <skr-button
          size="xl"
          color="error"
          data-cy="confirm_trial_cancel_button"
          variant="elevated"
          :loading="loading"
          @click="emit('cancel')"
        >
          {{ t('business.billing.plan.cancel_trial') }}
        </skr-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
